import { Card, CardContent } from "@/components/ui/card";
import { FileText } from "lucide-react";
import type { Facility } from "@shared/schema";

interface FacilityDocumentsTabProps {
  facility: Facility;
  dealId: string;
}

export function FacilityDocumentsTab({ facility: _facility, dealId: _dealId }: FacilityDocumentsTabProps) {
  // Documents for facilities - placeholder for future implementation
  // Document management will be added when the Documents module is built

  return (
    <div className="space-y-3">
      <Card>
        <CardContent className="pt-3">
          <div className="text-center py-8">
            <FileText className="h-8 w-8 text-muted-foreground mx-auto mb-2" />
            <p className="text-sm text-muted-foreground">
              Document management for facilities
            </p>
            <p className="text-xs text-muted-foreground mt-1">
              Coming soon - Upload and manage facility-specific documents
            </p>
          </div>
        </CardContent>
      </Card>
    </div>
  );
}
